window.onload = function() {

    $(window).trigger('js-onload');

};

$(function(){

    $.fn.disable = function(){
        return this.each(function(){
            $(this).prop('disabled', true);
        });
    };

    $.fn.enable = function(){
        return this.each(function(){
            $(this).prop('disabled', false);
        });
    };

    $.fn.stallPanel = function(button) {
        button = button || '.next-step';

        this.find(button).disable();
    };

    $.fn.releasePanel = function(button) {
        button = button || '.next-step';

        this.find(button).enable();
    };

    $.fn.serializeJSON = function(){
        let obj = {};

        $.each(this.serializeArray(), function(index, item){
            this[item.name] = item.value;
        }.bind(obj));

        return obj;
    };

    $.fn.preventDoubleSubmission = function(options) {
        options = $.extend({}, {
            showLoading: false,
            loadingClass: 'loading',
            targetSelector: '[type="submit"], [type="image"]'
        }, options);

        return this.each(function() {
            $(this).on('submit', function(event){
                var $form = $(this);

                if ($form.data('submitted') === true) {
                    // Previously submitted - don't submit again
                    event.preventDefault();
                    return false;
                }

                // Mark it so that the next submit can be ignored
                $form.data('submitted', true)
                    .find(options.targetSelector)
                        .prop('disabled', true)
                        .toggleClass(options.loadingClass, options.showLoading);
            });
        });
    };

    $.fn.preventReturnSubmit = function(options) {
        options = $.extend({}, {
            'child': null
        }, options);

        function preventReturn(event){
            var code = event.keyCode || event.which;
            if(code === 13) {
                event.preventDefault();
                return false;
            }
        }

        return this.each(function(){
            if(options.child) {
                $(this).on('keypress', options.child, preventReturn);
            } else {
                $(this).on('keypress', preventReturn);
            }
        });
    };

    $.fn.validateRecaptcha = function(options) {
        options = $.extend({}, options);

        return this.each(function(){
            var form = this;
            $(form).parsley(options).on('form:validate', function(formInstance){
                $('.g-recaptcha + .parsley-errors-list').remove();
                if(!grecaptcha || grecaptcha.getResponse().length === 0) {
                    formInstance.validationResult = false;

                    var errorList = '<ul class="parsley-errors-list filled text-error">';
                        errorList += '<li class="parsley-required">';
                        errorList += 'Please complete the reCaptcha challenge before submitting.';
                        errorList += '</li></ul>';

                    $('.g-recaptcha').after(errorList);

                    var $submit = $(this).find('button[type="submit"]:last');
                    if($submit.length > 0) {
                        $submit.enable().removeClass('loading');
                    }
                }
            }.bind(form));
        });
    };

    $.fn.prependAlert = function(message, type) {
        type = (type !== undefined) ? type : 'error';

        if(Handlebars.templates['alert'] === undefined) {
            return false;
        }

        var markup = Handlebars.templates['alert']({
            type: type,
            dismiss: true,
            msg: message
        });

        this.prepend( markup );
    };

    $.fn.getCountryStates = function(options) {
        var defaults = {
            'endpoint': '/states_by_country/'
        };

        options = $.extend({}, defaults, options);

        function fetchStates(event, callback) {
            var $el = $(this);
            var $target = $($el.data('state-target'));

            $el.add($target).disable();

            $.get(options.endpoint + $el.val(), null, null, 'json')
                .fail(function(xhr){
                    if(xhr.status === 404) {
                        alert(xhr.responseText);
                    }
                })
                .always(function(){
                    $el.add($target).enable();
                })
                .done(function(response){
                    if(typeof response === 'object' && $.isEmptyObject(response) === false) {
                        var $option = $('<option></option>');
                        var options = $.map(response, function(val, key){
                            return $option.clone(false, false).attr('value', key).text(val);
                        });

                        $target.empty().append(options);
                    }
                    // no states?

                    if(typeof callback == 'function') {
                      callback();
                    }
                });
        }

        return this.each(function(){
            if($(this).data('state-target')) {
                $(this).on('change', fetchStates);
            }
        });
    };

    $(window)
        .on('show.bs.modal', function() {
            $('html').addClass('modal-open');
        })
        .on('hidden.bs.modal', function() {
            $('html').removeClass('modal-open');
        });

    $('.prevent-resubmit').preventDoubleSubmission();
    $('.prevent-resubmit-and-load').preventDoubleSubmission({
        showLoading: true
    });

});


window.triggerDelete = function(identifier, event) {
    event.preventDefault();
    document.getElementById(identifier).submit();
};


window.isJson = function(str) {
    try {
        if (typeof str !== "string"){
            return false;
        }
        if(typeof JSON.parse(str) !== "object") {
            return false;
        }
        return true;
    } catch (e) {
        return false;
    }
};

window.messageFromXhrJson = function(json) {
    var errors = [], message;

    if(json.message !== undefined) {
        message = json.message;
    }

    if(
        json.message === 'The given data was invalid.'
        && json.errors !== undefined
    ) {
        $.each(json.errors, function(key, val) {
            errors.push(val[0]);
        });
        if(errors.length > 1) {
            message = '<ul><li>' + errors.join('</li><li>') + '</li></ul>';
        } else {
            message = errors[0];
        }
    }

    return message;
};

window.errorMessageFromXhr = function(xhr) {
    var json, message;

    if(xhr.responseJSON !== undefined) {
        json = xhr.responseJSON;
        message = messageFromXhrJson(json);
    } else if(xhr.responseText !== undefined) {
        message = xhr.responseText;

        if(isJson(xhr.responseText)) {
            json = JSON.parse(xhr.responseText);
            message = messageFromXhrJson(json);
        }
    }

    return message;
};
